import { useState, useEffect, useCallback } from 'react';
import uploadQueue from '../services/uploadQueue';

/**
 * Hook para interactuar con la cola de uploads offline
 *
 * @returns {Object} Estado y acciones de la cola
 * @returns {Array} returns.queue - Items en cola
 * @returns {boolean} returns.isOnline - Estado de conexion
 * @returns {boolean} returns.isProcessing - Si hay uploads en curso
 * @returns {number} returns.pendingCount - Items pendientes o con error
 * @returns {Function} returns.addUpload - Agregar upload a la cola
 * @returns {Function} returns.removeUpload - Remover item de la cola
 * @returns {Function} returns.retryAll - Reintentar todos los errores
 */
function useUploadQueue() {
  const [state, setState] = useState(uploadQueue.getState());

  useEffect(() => {
    return uploadQueue.subscribe(setState);
  }, []);

  const addUpload = useCallback(({ file, uploadFn, metadata }) => {
    return uploadQueue.add({ file, uploadFn, metadata });
  }, []);

  const removeUpload = useCallback((id) => {
    uploadQueue.remove(id);
  }, []);

  const retryAll = useCallback(() => {
    uploadQueue.retryAll();
  }, []);

  return {
    queue: state.queue,
    isOnline: state.isOnline,
    isProcessing: state.isProcessing,
    pendingCount: state.pendingCount,
    addUpload,
    removeUpload,
    retryAll
  };
}

export default useUploadQueue;
